import { QuizClientProvider } from '@lingoda/quiz-graphql';
import { once } from '@lingoda/utils';
import { createQuizClient } from './createQuizClient';

export const QuizGraphQLProvider = (props: React.PropsWithChildren) => {
    return <QuizClientProvider client={getQuizClient()}>{props.children}</QuizClientProvider>;
};

// StrictMode re-mounts hooks, so memoizing this with `useMemo` would build two clients.
const getQuizClient = once(createQuizClient);
